import useClientState from '@/state/useClientState';

export const setScrollCoordinates = (scrollLeft: number, scrollTop: number, offsetWidth: number) => {
  useClientState.setState(() => {
    return {
      scrollLeft,
      scrollTop,
      offsetWidth,
    };
  });
};
